import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { NotificationEffect } from "./effect";
import { NotificationReducer } from "./reducer";

@NgModule({
    imports: [
        EffectsModule.forFeature([NotificationEffect]),
        StoreModule.forFeature('notification', NotificationReducer)
    ]
})

export class NotificationStoreModule { }

export const notificationList = (store: any) => store && store.notification && store.notification.notificationList;
export const notificationByFieldList = (store: any) => store && store.notification && store.notification.notificationByFieldList;
export const notificationById = (store: any) => store && store.notification && store.notification.notificationById;
export const notificationTemplateList = (store: any) => store && store.notification && store.notification.notificationTemplateList;
export const addNotificationResponse = (store: any) => store && store.notification && store.notification.addNotificationResponse;
export const updateNotificationResponse = (store: any) => store && store.notification && store.notification.updateNotificationResponse;
export const deleteNotificationResponse = (store: any) => store && store.notification && store.notification.deleteNotificationResponse;
